// extracted by mini-css-extract-plugin
export default {"wrapper":"RecordCustomer_wrapper__gfV-R"};